module.exports = __webpack_public_path__ + "img/battle-ropes-in-sand-2.0c04a511.jpg";